import React, { useState, useEffect, useRef } from "react";
import { FormGroup, Button, Label } from "reactstrap";
import _ from "lodash-es";
import ControldocDataTable from "../../../../controldoc/datatable";

const BulkRequestZipDocumentTable = props => {
  const formName = props?.formName || "bulk_request_zip_document";

  const {
    showDistributionListFilter,
    tableConfirmDocument,
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    configuration: {
      defaultRequestParams
    },
    actions: {
      indexDocumentsPath,
      createService,
      getDocumentByIds
    },
    buttonActions
  } = props;

  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [bulkRequest, setBulkRequest] = useState(props?.bulkRequest);
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)
  const [hide, setHide] = useState(false);

  const toggleHide = () => {
    setHide(!hide)
  }

  useEffect(() => {
    if (hide === true) {
      getSelectedDocuments()
    }
  }, [hide])

  const getSelectedDocuments = () => {
    let ids = _.map(bulkRequest.items, "document_id")
    let formData = new FormData();

    _.each(ids, function (id, _index) {
      formData.append(
        `ids[]`, id || ""
      );
    });

    getDocumentByIds(defaultRequestParams, formData, response => {
      if (response?.status == 200) {
        setSelectedDocuments(response?.data?.documents)
      }
    })
  }


  const drawErrorMessage = () => {
    if (bulkRequest.items.length == 0) {
      setHide(false)
      swalWithBootstrap.fire({
        icon: "error",
        title: "Oops!",
        showCloseButton: false,
        showCancelButton: false,
        confirmButtonText: "<i class='fa fa-thumbs-up'></i> Aceptar",
        text: "Debes seleccionar al menos un documento para realizar la descarga"
      })
    }
  }

  const handleConfirmSubmit = () => {
    swalWithBootstrap.fire({
      title: I18n.t("bulk.request.zip.documents.form.confirm.title"),
      html: I18n.t("bulk.request.zip.documents.form.confirm.message")
    })
      .then(result => {
        if (result.isConfirmed) {
          handleSubmit();
        }
      });
  };

  const drawTextSubmitButton = () => {
    if (disabledSubmitButton) {
      return "Guardando información ...";
    } else {
      return I18n.t("actions.save");
    }
  };

  const drawSubmitButton = () => {
    return (
      <Button
        color="success"
        className="ml-2"
        onClick={handleConfirmSubmit}
        disabled={disabledSubmitButton || selectedDocuments.length == 0}
      >
        {drawTextSubmitButton()}
      </Button>
    );
  };

  const drawNextPageButton = () => {
    return (
      <Button
        color="success"
        className="ml-2"
        onClick={() => { toggleHide(), drawErrorMessage() }}
      >
        Siguiente
      </Button>
    );
  }

  const drawReturnPageButton = () => {
    return (
      <Button
        color="success"
        className="btn btn-default"
        onClick={() => toggleHide()}
      >
        Volver al listado de documentos
      </Button>
    );
  }

  const handleSubmit = () => {
    let formData = getFormData();
    setDisabledSubmitButton(true);

    createService(defaultRequestParams, formData, response => {
      if (response.status == 201) {
        window.location = buttonActions.show({ ...defaultRequestParams, id: response.data.hashid, _options: true });
      } else if (response.status == 422) {
        setBulkRequest(response.data);
      }
    });
  };

  const getFormData = () => {
    let _formData = new FormData();
    _.each(bulkRequest.items, function (item, _index) {
      _formData.append(`${formName}[items_attributes][${_index}][document_id]`, item.document_id || "");
    });

    return _formData;
  }

  const handleBulkRequestData = (e, key) => {
    let value = e?.target?.value;
    let _bulkRequest = { ...bulkRequest };

    if (key == "documents" && e.target.checked) {
      _bulkRequest.items.push({ document_id: value });
    } else if (key == "documents" && !e.target.checked) {
      _.remove(_bulkRequest.items, item => String(item.document_id) == String(value));
      _.remove(selectedDocuments, d => String(d.id) == String(value));
    }

    setBulkRequest(_bulkRequest);
  };

  const drawDeleteSelectedDocument = document => {
    let _event = { target: { value: document.id } }
    return (
      <Button
        color="danger"
        outline
        className="border-0"
        onClick={e => handleBulkRequestData(_event, "documents")}
      >
        <i className="fas fa-trash-alt" />
      </Button>
    )
  }

  const drawTableConfirmDocument = () => {
    if (selectedDocuments.length > 0) {
      return tableConfirmDocument(selectedDocuments, drawDeleteSelectedDocument)
    } else {
      return (
        <div className="row">
          <div className="col-12">
            <div className="alert alert-danger text-center">Debes seleccionar al menos un documento</div>
          </div>
        </div>
      )
    }
  }

  const drawTabConfirm = () => {
    return (
      <div className="row">
        <div className="col-12" style={{ display: hide ? "block" : "none" }}>
          <Label className="d-flex justify-content-center h5 my-4">{`Documentos seleccionados: ${selectedDocuments.length}`}</Label>
          {drawTableConfirmDocument()}
          <FormGroup className="text-end mt-5">
            <div>
              {drawReturnPageButton()}
              {drawSubmitButton()}
            </div>
          </FormGroup>
        </div>
      </div>
    )
  }

  const onSelectionChange = selectedRecords => {
    setSelectedDocuments(selectedRecords);
    setBulkRequest(prevState => {
      return {
        ...prevState,
        items: _.uniqBy(selectedRecords.map(record => ({ document_id: record.id })), 'document_id')
      }
    })
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="row" style={{ display: hide ? "none" : "block" }}>
          <div className="col-12">
            <Label className="d-flex justify-content-center h5 my-4">Lista de documentos</Label>
            <ControldocDataTable
              columns={dataTableColumns}
              configuration={{
                showDistributionListFilter: showDistributionListFilter || false,
                context: "laboral",
                showGridlines: true,
                selectable: {
                  enabled: true,
                  mode: 'multiple',
                  selection: selectedDocuments,
                  onSelectionChange: onSelectionChange
                },
                fetchRecords: {
                  endpoint: indexDocumentsPath,
                  keyName: "documents",
                  defaultRequestParams: defaultRequestParams
                }

              }}
            >
            </ControldocDataTable>
          </div>
          <FormGroup className="text-end mt-5">
            <div>
              <a
                href={buttonActions.back}
                className="btn btn-default"
              >
                {I18n.t("actions.back")}
              </a>
              {drawNextPageButton()}
            </div>
          </FormGroup>
        </div>
        {drawTabConfirm()}
      </div>
    </div >
  )
}


export default BulkRequestZipDocumentTable;
